import { fetchCurrencyForCountryCode } from './graphQlSvc';

const JoinDetailsAction = {

    SET_PROPERTY_NAME: 'SET_PROPERTY_NAME',
    SET_LATIN_PROPERTY_NAME: 'SET_LATIN_PROPERTY_NAME',
    SET_PROPERTY_TYPE: 'SET_PROPERTY_TYPE',
    SET_CURRENCY_CODE: 'SET_CURRENCY_CODE',
    SET_UNIT_COUNT: 'SET_UNIT_COUNT',
    SET_MANAGER_INFO: 'SET_MANAGER_INFO',
    SET_CHAIN_INFO: 'SET_CHAIN_INFO',
    SET_PROPERTY_NAME_VALIDATION: 'SET_PROPERTY_NAME_VALIDATION',
    SET_LATIN_PROPERTY_NAME_VALIDATION: 'SET_LATIN_PROPERTY_NAME_VALIDATION',
    SET_PROPERTY_TYPE_VALIDATION: 'SET_PROPERTY_TYPE_VALIDATION',
    SET_UNIT_COUNT_VALIDATION: 'SET_UNIT_COUNT_VALIDATION',
    SET_CURRENCY_VALIDATION: 'SET_CURRENCY_VALIDATION',
    FETCH_CURRENCY_START: 'FETCH_CURRENCY_START',
    FETCH_CURRENCY_SUCCESS: 'FETCH_CURRENCY_SUCCESS',
    FETCH_CURRENCY_FAIL: 'FETCH_CURRENCY_FAIL',

    SET_LEGAL_NAME: 'SET_LEGAL_NAME',
    SET_LEGAL_NAME_VALIDATION: 'SET_LEGAL_NAME_VALIDATION',

    SET_COMPETITOR_LINK: 'SET_COMPETITOR_LINK',
    SET_COMPETITOR_LINK_LOADING: 'SET_COMPETITOR_LINK_LOADING',
    SET_WEBSITE_URL: 'SET_WEBSITE_URL',
    SET_WEBSITE_URL_VALIDATION: 'SET_WEBSITE_URL_VALIDATION',

    SET_SUBMARKET_ID: 'SET_SUBMARKET_ID',

    setSubmarketId: submarketId => ({
        type: JoinDetailsAction.SET_SUBMARKET_ID,
        submarketId,
        persist: true
    }),

    clearSubmarketId: () => ({
        type: JoinDetailsAction.SET_SUBMARKET_ID,
        submarketId: undefined,
        persist: true
    }),

    setWebsiteUrl: websiteUrl => ({
        type: JoinDetailsAction.SET_WEBSITE_URL,
        websiteUrl,
        persist: true
    }),
    setWebsiteUrlValidation: result => ({
        type: JoinDetailsAction.SET_WEBSITE_URL_VALIDATION,
        result
    }),

    setCompetitorUrl: competitorUrl => ({
        type: JoinDetailsAction.SET_COMPETITOR_LINK,
        competitorUrl,
        persist: true
    }),
    setCompetitorUrlLoading: competitorUrlLoading => ({
        type: JoinDetailsAction.SET_COMPETITOR_LINK_LOADING,
        competitorUrlLoading
    }),

    setLegalName: legalName => ({
        type: JoinDetailsAction.SET_LEGAL_NAME,
        legalName,
        persist: true
    }),
    setLegalNameValidation: result => ({
        type: JoinDetailsAction.SET_LEGAL_NAME_VALIDATION,
        result
    }),

    setPropertyName: propertyName => ({
        type: JoinDetailsAction.SET_PROPERTY_NAME,
        propertyName,
        persist: true
    }),
    setPropertyNameValidation: result => ({
        type: JoinDetailsAction.SET_PROPERTY_NAME_VALIDATION,
        result
    }),
    setLatinPropertyName: latinPropertyName => ({
        type: JoinDetailsAction.SET_LATIN_PROPERTY_NAME,
        latinPropertyName,
        persist: true
    }),
    setLatinPropertyNameValidation: result => ({
        type: JoinDetailsAction.SET_LATIN_PROPERTY_NAME_VALIDATION,
        result
    }),
    setPropertyType: propertyType => ({
        type: JoinDetailsAction.SET_PROPERTY_TYPE,
        propertyType,
        persist: true
    }),
    setPropertyTypeValidation: result => ({
        type: JoinDetailsAction.SET_PROPERTY_TYPE_VALIDATION,
        result
    }),
    setCurrency: currency => ({
        type: JoinDetailsAction.SET_CURRENCY_CODE,
        currency,
        persist: true
    }),
    setCurrencyValidation: result => ({
        type: JoinDetailsAction.SET_CURRENCY_VALIDATION,
        result
    }),
    setUnitCount: unitCount => ({
        type: JoinDetailsAction.SET_UNIT_COUNT,
        unitCount,
        persist: true
    }),
    setUnitCountValidation: result => ({
        type: JoinDetailsAction.SET_UNIT_COUNT_VALIDATION,
        result
    }),
    setManagerInfo: managerInfo => ({
        type: JoinDetailsAction.SET_MANAGER_INFO,
        managerInfo,
        persist: true
    }),
    setChainInfo: chainInfo => ({
        type: JoinDetailsAction.SET_CHAIN_INFO,
        chainInfo,
        persist: true
    }),
    fetchCurrencyOnCountryCode: (countryCode) => {
        const start = () => ({ type: JoinDetailsAction.FETCH_CURRENCY_START });
        const success = currencyList => ({
            type: JoinDetailsAction.FETCH_CURRENCY_SUCCESS,
            currencyList
        });
        const fail = error => ({ type: JoinDetailsAction.FETCH_CURRENCY_FAIL, error });
        return dispatch => dispatch(fetchCurrencyForCountryCode(countryCode, start, success, fail));
    }
};

export default JoinDetailsAction;
